'use strict';

var analysisModule = angular.module("app.analysisModule", []);

analysisModule.config(["$stateProvider", "$locationProvider",
  function (
    $stateProvider: ng.ui.IStateProvider,
    $locationProvider: angular.ILocationProvider) {

    console.log('app.analysisModule config...');

    var wholesaleClientChecker = ['sessionService', '$q', '$state', 'userCompanyService', function (sessionService, $q, $state,userCompanyService) {
      var deferred = $q.defer();
      userCompanyService.getUserCompany().then((company) => {
        if (sessionService.getCurrentUserProfile().wholesaleclient === 'True' && !company.enableWholesaleClientsResearch) {
          $state.go('dashboard');
          deferred.reject();
        } else {
          deferred.resolve();
        }
      })
      return deferred.promise;
    }]

    $stateProvider
      .state("watchlist",
        {
          url: "/watchlists?add",
          templateUrl: "assets/templates/Analysis/watchlists.html",
          controller: 'watchlistsCtrl',
          resolve: {
            meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                $rootScope.meta = {title: "Watchlists"};
            }],
            wholesaleClientCheck: wholesaleClientChecker
          }
        })
      .state("watchlistView",
        {
          url: "/watchlists/view?watchlistId?secIds",
          templateUrl: "assets/templates/Analysis/watchlistItem.html",
          controller: 'watchlistItemCtrl',
          resolve: {
            meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
              $rootScope.meta = {title: "Watchlists"};
            }],
            wholesaleClientCheck: wholesaleClientChecker
          }
        })
      .state("heatmap",
        {
          url: "/heatmap?watchlistId",
          templateUrl: "assets/templates/Analysis/marketHeatmap.html",
          controller: 'marketHeatmapCtrl',
          resolve: {
            meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
              $rootScope.meta = {title: "Market Heatmap"};
            }],
            wholesaleClientCheck: wholesaleClientChecker
          }
        })
      .state("charts",
        {
          url: "/charts?secIds",
          templateUrl: "assets/templates/Analysis/marketCharts.html",
          controller: 'marketChartCtrl',
          resolve: {
            meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
              $rootScope.meta = {title: "Charting Tools"};
            }],
            wholesaleClientCheck: wholesaleClientChecker
          }
        })
      .state("stockCompare",
        {
          url: "/stockCompare?secIds",
          templateUrl: "assets/templates/Analysis/stockCompare.html",
          controller: 'stockCompareCtrl',
          resolve: {
            meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
              $rootScope.meta = {title: "Equities Comparison"};
            }],
            wholesaleClientCheck: wholesaleClientChecker
          }
        })
      // .state("fundCompare",
      //   {
      //     url: "/fundCompare?secIds",
      //     templateUrl: "assets/templates/Analysis/fundCompare.html",
      //     controller: 'fundCompareCtrl',
      //     resolve: {
      //       wholesaleClientCheck: wholesaleClientChecker,
      //       impersonatorCheck: ['sessionService', '$q', '$state', function (sessionService, $q, $state) {
      //         var deferred = $q.defer();
      //         if (sessionService.getCurrentUserProfile().impersonator === 'True') {
      //           $state.go('dashboard');
      //           deferred.reject();
      //         } else {
      //           deferred.resolve();
      //         }
      //         return deferred.promise;
      //       }]
      //     }
      //   })
      // .state("etfCompare",
      //   {
      //     url: "/etfCompare?secIds",
      //     templateUrl: "assets/templates/Analysis/etfCompare.html",
      //     controller: 'etfCompareCtrl',
      //     resolve: {
      //       wholesaleClientCheck: wholesaleClientChecker,
      //       impersonatorCheck: ['sessionService', '$q', '$state', function (sessionService, $q, $state) {
      //         var deferred = $q.defer();
      //         if (sessionService.getCurrentUserProfile().impersonator === 'True') {
      //           $state.go('dashboard');
      //           deferred.reject();
      //         } else {
      //           deferred.resolve();
      //         }
      //         return deferred.promise;
      //       }]
      //     }
      //   })
  }]);

analysisModule.controller('analysisBaseCtrl', Patersons.AnalysisBaseCtrl);
analysisModule.controller('watchlistsCtrl', Patersons.WatchlistsCtrl);
analysisModule.controller('watchlistItemCtrl', Patersons.WatchlistItemCtrl);
analysisModule.controller('marketHeatmapCtrl', Patersons.MarketHeatmapCtrl);
analysisModule.controller('marketChartCtrl', Patersons.MarketChartCtrl);
analysisModule.controller('stockCompareCtrl', Patersons.StockCompareCtrl);
analysisModule.controller('fundCompareCtrl', Patersons.FundCompareCtrl);
analysisModule.controller('etfCompareCtrl', Patersons.ETFCompareCtrl);

